<div fxLayout="column" fxLayoutAlign="center center">

    <h2 style="font-weight:bold; padding-left:20px; text-align:center;">{{'CONFIRMACION.FELICI' | translate}}</h2>
    <ng-container *ngIf="institutoId=='1'">
      <ng-container *ngIf="statusConfirmInfoJP==0">
        <h3 style="font-weight:bold; padding-left:20px; text-align:center">{{'CONFIRMACION.IND_CONFIRM_JP' | translate}}</h3>
        <div class="p-16 " fxLayout="row" fxLayoutAlign="center center">
          <button class="btn-Confirm" mat-raised-button color="accent" (click)="modalConfirmacionV2();">{{'CONFIRMACION.BTN_CONFIRM_INFO' | translate}}<mat-icon>check</mat-icon></button>
        </div>
      </ng-container>
      <ng-container *ngIf="statusConfirmInfoJP==1">
        <div class="statusDivAlert" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" >
          <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="ml-20 s-40">info</mat-icon>
            <h2>{{'CONFIRMACION.IND_ESP_CONFIRM_JP' | translate}}</h2>
          </div>
        </div>
      </ng-container>
      <h3 style="font-weight:bold; padding-left:20px; text-align:center;">{{'CONFIRMACION.INDICACION' | translate}}</h3>
      <h3 *ngIf="statusSurvey==1" style="font-weight:bold; padding-left:20px; text-align:center;color:#99BC8A">{{'CONFIRMACION.MESSAGE5' | translate}}</h3>
      <div *ngIf="statusSurvey==0" class="p-16 " fxLayout="row" fxLayoutAlign="center center">
        <button  *ngIf="!usuarioAdmin" class="btn-Activar" mat-raised-button color="primary" (click)="activarEncuesta();"  [disabled]="statusConfirmInfoJP!=2">{{'CONFIRMACION.CONFIRMAR' | translate}}</button>
        <button  *ngIf="usuarioAdmin" class="btn-Activar" mat-raised-button color="primary" (click)="activarEncuestaAdmin();" >{{'CONFIRMACION.CONFIRMAR' | translate}}</button>
        <!-- <button class="btn-Activar" mat-raised-button color="primary" (click)="modalConfirmacion();" [disabled]="!confirmInfoJP">{{'CONFIRMACION.CONFIRMAR' | translate}}</button> -->
      </div>
    </ng-container>
    <ng-container *ngIf="institutoId!='1'">
      <h3 style="font-weight:bold; padding-left:20px; text-align:center;">{{'CONFIRMACION.INDICACION' | translate}}</h3>
      <div *ngIf="statusSurvey==0" class="p-16 " fxLayout="row" fxLayoutAlign="center center">
        <button class="btn-Activar" mat-raised-button color="primary" (click)="modalConfirmacion();">{{'CONFIRMACION.CONFIRMAR' | translate}}</button>
      </div>
    </ng-container>
    <!-- <ng-container *ngIf="confirmInfoJP"> -->
      <div *ngIf="statusSurvey==1" class="p-16" fxLayoutAlign="center center">
      <div class="h1">
        <button style="background-color: #0E35F4; color:white" mat-raised-button (click)="desactivarEncuesta();">{{'CONFIRMACION.CERRAR-CONFIRMAR' | translate}}</button></div>
      </div>
      <ng-container *ngIf="historySurveyActiDesacti.length > 0">
        <h3 style="font-weight:bold; padding-left:20px; text-align:center">{{'CONFIRMACION.HISTORY_ACTIVATION_1' | translate}}</h3>
        <h3 *ngIf="surveyActiDesacti" style="padding-left:20px; margin-top:0px;text-align:center; color:#C9CACD">{{fechaUltimaSurveyActiDesacti.createdAt |date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{fechaUltimaSurveyActiDesacti.createdAt |date:'O':offsetPipe:idiomaActual}}) {{'CONFIRMACION.ESTATUS_SURVEY.'+fechaUltimaSurveyActiDesacti.surveyStatus | translate}}</h3>
        <div class="" fxLayoutAlign="center center">
          <mat-expansion-panel class="mb-20 accent-50" *ngIf="surveyActiDesacti">
            <mat-expansion-panel-header>
              <mat-panel-title style="font-weight:bold; padding-left:20px; text-align:center">
                {{'CONFIRMACION.HISTORY_ACTIVATION_2' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list>
              <mat-list-item *ngFor="let histoGeneration of historySurveyActiDesacti  let y = index">
                <p class="fz14 mr-20" style="color:#C9CACD">{{y}}) {{histoGeneration.createdAt |date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{histoGeneration.createdAt |date:'O':offsetPipe:idiomaActual}}) - {{'CONFIRMACION.ESTATUS_SURVEY.'+histoGeneration.surveyStatus | translate}}</p>
                <mat-divider></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>
        </div>
      </ng-container>
    <!-- </ng-container> -->
</div>
